import React from 'react';
import ReactDOM from 'react-dom';
import App from 'App';
import Modal from 'react-modal';
import { persistCache } from 'apollo-cache-persist';
import { cache } from 'services/apollo-client';
import * as serviceWorker from './serviceWorker';
import * as Sentry from '@sentry/browser';
import { toast } from 'services/toast';
import { cssTransition } from 'react-toastify';
import 'index.css';
import 'react-toastify/dist/ReactToastify.css';
import 'simplebar/dist/simplebar.min.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/amiri/700.css';

toast.configure({
  position: toast.POSITION.BOTTOM_CENTER,
  closeButton: false,
  transition: cssTransition({
    enter: 'zoomIn',
    exit: 'zoomOut',
  }),
});

export const APP_ROOT_ELEMENT = document.getElementById('root');

async function initApp() {
  // await before instantiating ApolloClient, else queries might run before the cache is persisted
  await persistCache({
    cache,
    // @ts-ignore
    storage: window.sessionStorage,
    key: 'cortlex-state',
  });

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    beforeSend(event, hint) {
      // @ts-ignore
      const isAuthError = hint?.originalException?.networkError?.result?.errors.some(
        (error) => error.extensions.code === 'UNAUTHENTICATED',
      );

      if (isAuthError) {
        return null;
      }

      return null;
    },
  });

  Modal.setAppElement(APP_ROOT_ELEMENT);

  ReactDOM.render(<App />, APP_ROOT_ELEMENT);

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  serviceWorker.register();
}

initApp();
